import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/scss/main.scss'
import sectionHeading from '@/components/common/SectionHeading.vue';


Vue.component('sectionHeading', sectionHeading)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

